<template>
  <span class="check-success">
    <transition name="fade">
      <svg v-if="showSuccess" width="20px" height="20px" viewBox="0 0 28 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <defs>
          <path id="path-1" d="M9.73960768,19.5080736 L9.70568722,19.541994 L0.075,9.91130682 L2.40845238,7.57785444 L9.72453192,14.893934 L24.5556872,0.0627786822 L26.8891396,2.39623106 L9.75845238,19.5269183 L9.73960768,19.5080736 Z" />
        </defs>
        <g id="Info" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
          <g id="Reference" transform="translate(-104.000000, -1843.000000)">
            <g id="Check_Blue" transform="translate(103.000000, 1837.000000)">
              <g id="Check">
                <g id="Icon" transform="translate(1.500000, 6.450000)">
                  <mask id="mask-2" fill="white">
                    <use xlink:href="#path-1" />
                  </mask>
                  <use id="Mask" fill="#000000" xlink:href="#path-1" />
                  <g id="Blue" mask="url(#mask-2)" fill="#0F91C2">
                    <g id="Rectangle-2" transform="translate(-1.500000, -6.450000)">
                      <rect x="0" y="0" width="30" height="30" />
                    </g>
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </svg>
    </transition>
  </span>
</template>

<script>
export default {
  data() {
    return {
      showSuccess: false
    }
  },

  methods: {
    toggle() {
      this.showSuccess = true
      setTimeout(() => {
        this.showSuccess = false
      }, 500)
    }
  }
}
</script>


<style lang="scss" scoped>
  .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter-from, .fade-leave-to {
    opacity: 0;
  }
  .check-success {
    display: inline-block;
    width:20px;

    svg {
      display: inline-block;
      vertical-align: middle;
    }
  }
</style>
